import classnames from 'classnames';

import RichText from 'molecules/RichText';
import Stats from 'molecules/Stats';

import styles from 'components/Metrics/metrics.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { MetricsProps } from 'components/Metrics/config';
import type { FeaturedTextStatsProps } from 'molecules/Stats';
import type { ComponentPropsWithoutRef, FC } from 'react';

type ComponentMetricsProps = MetricsProps &
  Pick<FeaturedTextStatsProps, 'featuredStats'> &
  ComponentPropsWithoutRef<'section'>;

const Metrics: FC<ComponentMetricsProps> = ({ backgroundColor, eyebrow, body, removeSpaceBetween, featuredStats }) => {
  const wrapperClass = classnames(styles.wrapper, {
    [styles.bkgMystic]: backgroundColor === 'mystic',
  });
  const containerClass = classnames(styles.contentContainer, styles.layoutOneColumn);
  const statClasses = classnames(styles.statsContainer);

  return (
    <section className={wrapperClass}>
      <div className={containerClass}>
        <div className={styles.bodyContainer}>
          {eyebrow && <p className={styles.heading}>{eyebrow}</p>}
          {body && <RichText className={styles.bodyText} content={body} />}
          {!removeSpaceBetween && <br />}
          {isNonEmptyArray(featuredStats) && (
            <Stats featuredStats={featuredStats} className={statClasses} statClass={styles.stat} />
          )}
        </div>
      </div>
    </section>
  );
};

export default Metrics;
